import { render, staticRenderFns } from "./InsuranceMonth.vue?vue&type=template&id=2a81adee&scoped=true"
import script from "./InsuranceMonth.vue?vue&type=script&lang=js"
export * from "./InsuranceMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a81adee",
  null
  
)

export default component.exports